import { useQuery } from "react-query";
import { EnvURL } from "../enums";
import { find } from "../services";

export function useFindEnvs() {
  return useQuery(EnvURL.Configurations, () => find());
}
